// extracted by mini-css-extract-plugin
export default {"companyContainer":"aL-z","companyImage":"bL-z","container":"cL-z","heading":"dL-z","darkText":"eL-z","smallHeading":"fL-z","darkBackground":"gL-z","whiteBackground":"hL-z"};